import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EntityWithUuid, NkCardListConfig, NkCardListItemConfig } from '../card-list.utils';

import { TranslateModule } from '@ngx-translate/core';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { FADE_ANIMATION } from '../../../utils/animations.utils';
import { CardContentComponent } from '../../card/card-content/card-content.component';
import { CardComponent } from '../../card/card/card.component';
import { CaretExpanderComponent } from '../../caret-expander/caret-expander.component';
import { HelpPopoverComponent } from '../../help-popover/help-popover.component';
import { CardListItemDetailsDirective } from '../directives/card-list-item-details.directive';
import { CardListItemDirective } from '../directives/card-list-item.directive';

@Component({
  selector: 'nk-card-list-item',
  imports: [
    CollapseModule,
    CardComponent,
    CardContentComponent,
    CardListItemDirective,
    CardListItemDetailsDirective,
    TranslateModule,
    HelpPopoverComponent,
    CaretExpanderComponent,
  ],
  templateUrl: './card-list-item.component.html',
  animations: [FADE_ANIMATION],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListItemComponent<Entity extends EntityWithUuid> {
  @Input() public entity: Entity | undefined;
  @Input() public detailsComponent: NkCardListConfig<Entity>['detailsComponent'];
  @Input() public items: NkCardListItemConfig<Entity>[] | undefined;
  @Input() public noBorder = false;
  @Input() public collapsibleDetails = true;

  public isCollapsed = true;
}
